
    const data = {"name":"src/core/icons/security","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 12h7c-.53 4.11-3.28 7.78-7 8.92V12H5V6.3l7-3.11M12 1 3 5v6c0 5.55 3.84 10.73 9 12 5.16-1.27 9-6.45 9-12V5l-9-4Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            